import React, { useState } from "react";
import "./mission.css";
import bg from "../../assets/images/About/bg-content.png";
import Arrow from "../../assets/images/Services/right-arrow.png";

const MissionVision = () => {
  const [activeTab, setActiveTab] = useState("mission");

  const missionContent = (
    <>
    
      <p className="mv-1">
        At Horizon Webinfo Pvt Ltd, our mission is to deliver unparalleled IT solutions and consultancy services, distinguished by:
      </p>
      <div className="mv-bullet-listt">
        <p><img src={Arrow} /><span>Innovative Excellence: </span>We commit to being at the forefront of technological innovation, providing our clients with cutting-edge solutions that propel them into the future.</p>
        <p><img src={Arrow} /><span>Client-Centric Collaboration: </span>We forge enduring partnerships with our clients, understanding their unique needs, and tailoring solutions that drive their success.</p>
        <p><img src={Arrow} /><span>Holistic Consultancy: </span> We offer comprehensive consultancy services, guiding businesses through strategic IT decisions, ensuring efficiency, and fostering sustainable growth.</p>
        <p><img src={Arrow} /><span>Ethical and Responsible Practices: </span>Upholding the highest ethical standards in our operations, we conduct business with integrity, transparency, and a commitment to social responsibility.</p>
        <p><img src={Arrow} /><span>Continuous Learning and Adaptation: </span>In the ever-evolving landscape of technology, we embrace continuous learning, adapting to emerging trends to provide our clients with solutions that stand the test of time.</p>
      </div>
      <p className="mv-2">At Horizon Webinfo Pvt Ltd, we are dedicated to the relentless pursuit of excellence, driven by a passion for technology and a genuine commitment to the success of our clients since our inception in 2005.”</p>
    </>
  );

  const visionContent = (
    <p className="mv-3">
Empowering a future where technology seamlessly integrates with human endeavors, fostering innovation, connectivity, and empowerment on a global scale. We envision a world where cutting-edge solutions transcend boundaries, enriching lives and propelling businesses toward unparalleled success. Our vision is to be a beacon of transformative technology, inspiring positive change, and contributing to a connected, inclusive, and sustainable future. At the heart of our vision lies a commitment to excellence, innovation, and ethical practices, shaping a digital landscape where every interaction is an opportunity for progress and every challenge is met with unparalleled technological ingenuity. </p>
  );

  return (
    <section  className="about-one style-two" style={{backgroundImage:`url(${bg})`}}>
    <div className="mv-container">
      <div className="mv-button-group">
        <button
          className={`mv-button ${activeTab === "mission" ? "active" : ""}`}
          onClick={() => setActiveTab("mission")}
        >
          MISSION @ HWPL! 
        </button>
        <button
          className={`mv-button ${activeTab === "vision" ? "active" : ""}`}
          onClick={() => setActiveTab("vision")}
        >
          VISION @ HWPL!
        </button>
      </div>

      <div className="mv-content-box">
        <div className="mv-text">
          {activeTab === "mission" ? missionContent : visionContent}
        </div>
      </div>
    </div>
    </section>
  );
};

export default MissionVision;
